class CartDrawer extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
		
        this.addEventListener("click", (event) => {
            if (event.target.tagName === 'CART-DRAWER') {
                this.close();
            }
        });
		this.setHeaderCartIconAccessibility();
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector('#cart-icon-bubble');
		if (cartLink) {
			cartLink.setAttribute('role', 'button');
			cartLink.setAttribute('aria-haspopup', 'dialog');
			cartLink.addEventListener('click', (event) => {
				event.preventDefault();

				this.open(cartLink);
			});

			cartLink.addEventListener('keydown', (event) => {
				if (event.code.toUpperCase() === 'SPACE') {
					event.preventDefault();
					this.open(cartLink);
				}
			});
		}
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		this.style.removeProperty("content-visibility");

		//const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		//if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

        setTimeout(() => {
			this.classList.add('active');

            this.addEventListener('transitionend', () => {
                const containerToTrapFocusOn = this.querySelector('.cart-drawer-inner');
                const focusElement = this.querySelector('#CartDrawer-close');
                trapFocus(containerToTrapFocusOn, focusElement);
            },{ once: true });
		}, 30);

		document.body.classList.add('overflow-hidden');
	}

	close() {
		this.classList.remove('active');
        //removeTrapFocus(this.activeElement);
		document.body.classList.remove('overflow-hidden');
	}

	disableCheckoutButton(){
		let checkoutButton;
		if(checkoutButton = document.getElementById('CartDrawer-Checkout')){
			checkoutButton.setAttribute('disabled', true);
		}
		
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute('role', 'button');
		cartDrawerNote.setAttribute('aria-expanded', 'false');

		if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
			cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
		}

		cartDrawerNote.addEventListener('click', (event) => {
			event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
		});

		cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
	}

	renderContents(parsedState) {
        let itemsCount = parsedState?.item_count;
        if(itemsCount != null){
            this.classList.toggle('is-empty', itemsCount === 0);
        };
		//this.classList.contains('is-empty') && this.classList.remove('is-empty');

		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);

			if (!sectionElement) return;
			sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
		});

		setTimeout(() => {
			this.open();
		});
	}

    getCart() {
        return fetch(`${routes.cart_url}`, { ...fetchConfig() })
            .then((response) => response.json());
    }

	removeCartItems(items, renderContents = false) {
		this.disableCheckoutButton();

		let updates = {};

		items.forEach((item) => {
			updates = { ...updates, [item.id]: 0 };
		});

		const body = JSON.stringify({
			updates,
			sections: this.getSectionsToRender().map((section) => section.id),
			sections_url: window.location.pathname,
		});

        return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
				return response.status === 200 && response.json();
			}).then((response) => {
                this.renderContents(response);

                publish(PUB_SUB_EVENTS.cartUpdate, {
					source: 'cart-drawer',
					cartData: response
				});
				

				return response;
			}).catch((e) => {
				console.log(e);
			})
    }

	getSectionInnerHTML(html, selector = '.shopify-section') {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: 'cart-drawer'
			},
            {
				section: 'cart-drawer',
                id: 'cart-drawer-items',
				selector: '[data-cart-items]'
			},
            {
                section: 'cart-drawer',
				id: 'cart-gwp',
                selector: '[data-cart-gwp-selector]'
			},
			{
				section: 'cart-icon-bubble',
				id: 'cart-icon-bubble'
			}
		];
	}

	getSectionDOM(html, selector = '.shopify-section') {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}
customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
            {
                section: 'cart-drawer',
				id: 'cart-title',
				selector: '[data-cart-title]'
			},
			{
				section: 'cart-drawer',
                id: 'cart-drawer-items',
				selector: '[data-cart-items]'
			},
            {
                section: 'cart-drawer',
				id: 'cart-gwp',
                selector: '[data-cart-gwp-selector]'
			},
			{
				section: 'cart-drawer',
                id: 'cart-footer',
				selector: '[data-cart-footer]'
			},
            {
				section: 'cart-drawer',
                id: 'cart-empty-content',
				selector: '[data-cart-empty]'
			},
			{
				id: 'cart-icon-bubble',
				section: 'cart-icon-bubble',
				selector: '.shopify-section'
			}
		];
	}
}
customElements.define('cart-drawer-items', CartDrawerItems);

class CartDrawerGWPMeter extends HTMLElement {
	constructor() {
		super();
        this.cartUpdateUnsubscriber = undefined;
        this.enabled = CART_DRAWER.gwp_enabled;
		this.gwpThreshold = CART_DRAWER.gwp_threshold;
        this.progress = 0;
        this.cartSubtotal = this.dataset.cartSubtotal;

        this.emptymsg = this.querySelector("[data-meter-message='empty']");
		this.fullmsg = this.querySelector("[data-meter-message='full']");

		this.remaining = this.emptymsg.querySelector("span");
	}

	connectedCallback() {
		if(this.enabled != true || Math.sign(this.gwpThreshold) !== 1 ){//|| CART_DRAWER.gwp_products.length === 0
			this.remove();
			return;
		}

		this.calculateProgress();

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
			this.calculateProgress(event);
		});
	}

	disconnectedCallback(){

	}

    async calculateProgress(response){
		let cart = await this.getCart();
		let donationProductPrice = 0;
        this.cartSubtotal = cart?.items_subtotal_price ?? 0;

		cart.items.forEach((item) => {
			if(item.sku == '21765') {
				donationProductPrice = item.original_line_price;
			}
		});

		this.progress = ((this.cartSubtotal - donationProductPrice) / this.gwpThreshold ).toFixed(2) * 100;

        if (this.progress >= 100) {
            this.style.setProperty("--CartDrawer--gwp_progress", "100%");

            this.emptymsg.classList.add("d-none");;
			this.fullmsg.classList.remove("d-none");;
        } else {
            this.style.setProperty("--CartDrawer--gwp_progress", this.progress + "%");

            if (this.remaining) {
                this.remaining.innerText = Shopify.formatMoney(this.gwpThreshold - (this.cartSubtotal - donationProductPrice));
            }

            this.emptymsg.classList.remove("d-none");
			this.fullmsg.classList.add("d-none");
        }
    }

    getCart() {
        return fetch(`${routes.cart_url}`, { ...fetchConfig() })
            .then((response) => response.json());
    }
}
customElements.define('cart-drawer-gwp-meter', CartDrawerGWPMeter);

function enforce_promotions(cart) {
	const CART_DRAWER_ELEM = document.querySelector("cart-drawer");
	let freeSamplesInCart = [];
	let freeSamplesQuantityCart = 0;

	//Grab free sample products from the cart
	cart.items.forEach((element, index) => {
		if(Object.keys(element.properties) == "_freeSample" || CART_DRAWER.gwp_products.includes(element.id)) {
			freeSamplesInCart[index + 1] = element;
			freeSamplesQuantityCart += element.quantity;
		}
	});

	if(cart.item_count > 0 && cart.item_count === freeSamplesQuantityCart){
		CART_DRAWER_ELEM.removeCartItems(freeSamplesInCart, true);
		return;
	}

	if(freeSamplesQuantityCart > CART_DRAWER.gwp_limit){
		CART_DRAWER_ELEM.removeCartItems(freeSamplesInCart, true);
		return;
	}

	if(CART_DRAWER.gwp_threshold > cart.items_subtotal_price && freeSamplesQuantityCart != 0){
		CART_DRAWER_ELEM.removeCartItems(freeSamplesInCart, true);
		return;
	}
}


async function grab_cart_and_enforce_promotions() {
	if(CART_DRAWER.gwp_products.length > 1){
		gwpSliderInit();
	}

	let cart = await fetch(`${routes.cart_url}`, { ...fetchConfig()})
		.then((resp) => {
			if (resp.ok) return resp.json();
			throw new Error(resp.status+':'+resp.statusText);
		}).then((cart) => {
			try{
				enforce_promotions(cart);
			}catch(e){
				console.log(e);
			}

			//hide_duplicate_upsells(cart);
			return cart;
		}).catch((e) => {
			console.log(e);
		});

	let gwpForm = document.querySelectorAll('form[name="gwp_form"]');

	if(gwpForm) {
		gwpForm.forEach((form) => {
            form.addEventListener("submit", (event) => {
                event.preventDefault();

                let promotionId = Number.parseInt(event.target['id'].value);

				if (!Number.isInteger(promotionId)) return;

				if(Object.values(CART_DRAWER.gwp_products).includes(promotionId)) {
					addPromoGift(cart, promotionId, event.submitter);
				}
            });
        });
	}
}

function upsellSliderInit(){
    let swiperUpsellElem = document.querySelector("[data-cart-upsell]");

    if(swiperUpsellElem){
        new Swiper(swiperUpsellElem, {
            speed: 400,
            autoPlay: false,
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            }
        });
    }
}

function gwpSliderInit(){
    let swiperElem = document.querySelector("[data-cart-gwp-selector-swiper]");

    if(swiperElem && !swiperElem.swiper){
        new Swiper(swiperElem, {
            speed: 400,
            autoPlay: false,
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            }
        });
    }
}

window.addEventListener('load', function () {
    if(CART_DRAWER.upsell !== false){
        upsellSliderInit();

        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            setTimeout(() => {
                upsellSliderInit();
            }, 301);
        });
    }

    if(CART_DRAWER.gwp_enabled !== false && CART_DRAWER.gwp_products.length !== 0) {
		grab_cart_and_enforce_promotions();

        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            grab_cart_and_enforce_promotions();
        });
    }
})

function addPromoGift(cartData, promotionId, submitterElement = false) {
	if(cartData.items_subtotal_price < CART_DRAWER.gwp_threshold) {
		return;
	}

	let cart = document.querySelector("cart-drawer");
	cart.disableCheckoutButton();

	if(submitterElement){
		submitterElement.setAttribute('disabled', true);
		submitterElement.setAttribute('aria-disabled', true);
		submitterElement.classList.add('loading');
		submitterElement.querySelector('.loading__spinner').classList.remove('hidden');
	}

	const body = JSON.stringify({
		id: promotionId,
		quantity: 1,
		properties: {
		  '_freeSample': true
		},
		sections: cart.getSectionsToRender().map((section) => section.id),
		sections_url: window.location.pathname,
	});
	
	fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
		.then((response) => {
			if (response.ok) return response.json();
			throw new Error(response.status+':'+response.statusText);
		}).then((response) => {
			cart.renderContents(response);

			publish(PUB_SUB_EVENTS.cartUpdate, {
				source: 'product-form',
				productVariantId: response.id,
				cartData: cartData,
			});
		}).catch((e) => {
			console.error('Fetch', e);
		});
}
document.addEventListener("submit", (e) => {
    var form = e.target, variant_id, qty;
    if (form && form.matches("[data-cartdrawer-upsellform]")) {
        variant_id = form.elements.id.value;
        qty = form.elements.quantity.value;
        e.preventDefault();
        add_upsell_to_cart(variant_id, qty);
    }
});

function add_upsell_to_cart(id, quantity) {
    var instance = document.querySelector("cart-drawer"),
    body = new FormData();
    body.append("id", id);
    body.append("quantity", quantity);
    body.append("sections", instance.getSectionsToRender().map((section) => section.id));

    fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        body: body
    }).then(function(resp) {
        if (resp.status === 200) {
            return resp.json();
        }
    }).then(function(resp) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'upsell',
            productVariantId: resp.id,
            cartData: resp
        });

        instance.renderContents(resp);
    });
}

